import { render } from "./TransactonPolicyPanel.vue?vue&type=template&id=db36cec8&scoped=true&ts=true"
import script from "./TransactonPolicyPanel.vue?vue&type=script&lang=ts"
export * from "./TransactonPolicyPanel.vue?vue&type=script&lang=ts"

import "./TransactonPolicyPanel.vue?vue&type=style&index=0&id=db36cec8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db36cec8"]])

export default __exports__